import React from 'react'
import PageTitle from './PageTitle';
import EduCard from "./EduCard";

const Education = (props) => {

    return (
        <section>
            <div className='education-wrapper common-padding'>
                <PageTitle title="Education" />
                <div className="mt-4 w-100 educard-wrapper">
                    <EduCard course="B.Sc." details="(Information Technology)" college="Shankar Narayan College" date="April 2019" />
                    <EduCard course="H.S.C." details="(Maharashtra State Board)" college="Mother Mary's Jr. College" date="February 2016" />
                    <EduCard course="S.S.C." details="(Maharashtra State Board)" college="The Saraswati Vidyalaya" date="March 2014" />
                </div>
            </div>

            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("about")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("experience")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default Education